class pouchAlert extends HTMLElement {
  constructor() {
    super();
    this.$alert = this.querySelector('.alert');
    this.$dismissBtn = this.querySelector('.dismiss-btn');
    this.autoCloseTimeout = null;
  }

  connectedCallback() {
    this.autoCloseTimeout = setTimeout(() => {
      this.dismissAlert();
    }, 5000);
    if (this.$dismissBtn) {
      this.$dismissBtn.addEventListener('click', this.dismissAlert.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }
    if (this.$dismissBtn) {
      this.$dismissBtn.removeEventListener('click', this.dismissAlert.bind(this));
    }
  }

  dismissAlert() {
    if (this.$alert) {
      this.$alert.classList.add('translate-x-full', 'opacity-0');
      setTimeout(() => {
        this.remove();
      }, 300);
    }
  }
}

customElements.define("pouch-alert", pouchAlert);

export default pouchAlert;